var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auto-shutdown',{attrs:{"disabled":_vm.disabled,"workspace":_vm.workspace,"loading":_vm.loading},model:{value:(_vm.showPopup),callback:function ($$v) {_vm.showPopup=$$v},expression:"showPopup"}})}
var staticRenderFns = []

export { render, staticRenderFns }